import { Alert } from '~/shadcn/components/ui/Alert';
import { AlertTriangle } from 'lucide-react';
/**
 * Alert for high variance.
 *
 * @param {object} props
 * @param {number} props.variancePercent - The variance percentage.
 * @param {number} props.expectedRemainingUnits - The expected remaining units.
 * @param {number} props.userDeclaredTotal - The user declared total.
 * @returns {JSX.Element}
 */
function HighVarianceAlert({ variancePercent, expectedRemainingUnits, userDeclaredTotal }) {
    return (
        <Alert variant="warning" className="bg-amber-50 border-amber-200 text-amber-500">
            <AlertTriangle className="h-4 w-4" />
            <p className="text-xs text-amber-800">
                <span className="font-semibold">High Variance Detected:</span> The remaining units you've entered (
                {userDeclaredTotal}) differ by <span className="font-bold">{variancePercent}</span> from the expected
                remaining units ({expectedRemainingUnits}). Please verify your counts before proceeding.
            </p>
        </Alert>
    );
}

export default HighVarianceAlert;
